import { FeatureFlagDTO, ToggleFeatureFlagDTO } from './feature-flag.protocols';
import axiosInstance from './api';

class FeatureFlagApi {
  static async getFeatureFlags(): Promise<FeatureFlagDTO[]> {
    const response: FeatureFlagDTO[] = await axiosInstance
      .get('/feature-flags')
      .then((response) => response.data);

    return response;
  }

  static async toggleFeatureFlag(
    key: string,
    dto: ToggleFeatureFlagDTO,
  ): Promise<FeatureFlagDTO> {
    const response: FeatureFlagDTO = await axiosInstance
      .patch(`/feature-flags/${key}`, dto)
      .then((response) => response.data);

    return response;
  }
}

export { FeatureFlagApi };
